import styled from 'styled-components';

import { breakpoint } from 'styles/mixins';

export const StyledFooter = styled.div`
	background-color: ${(p) => p.theme.color.bgColor};
	text-align: center;
	color: ${(p) => p.theme.color.grayDark};
	direction: rtl;
	border-top: 1px solid ${(p) => p.theme.color.grayDlight};

	&:before {
		display: table;
		content: ' ';
	}

	&:after {
		display: table;
		content: ' ';
		clear: both;
	}
`;

export const Wrapper = styled.div`
	padding: 10px 10px 15px;
	margin: 0 5%;
	width: 90%;
`;

export const Copyright = styled.p`
	float: right;
	width: 50%;
	text-align: right;
	margin: 1.5em 0;

	span {
		margin-left: 5px;
	}

	a {
		color: ${(p) => p.theme.color.primary};
	}
`;

export const Social = styled.div`
	text-align: center;
	margin: 1em 0;

	a {
		color: ${(p) => p.theme.color.grayDark};
		margin: 0 5px;

		${breakpoint.greaterThan('desktop')`
      &:hover {
        color: ${(p) => p.theme.color.primary};
      }
    `}

		.icon {
			font-size: 1.5rem;
		}
	}
`;

export const Designer = styled.div`
	background-color: #0b0b0b;
	color: ${(p) => p.theme.color.grayMedium};
	border: none;
	text-align: center;
	float: left;
	width: 100%;
	font-size: 0.875rem;
	padding: 15px 10px;
`;

export const DsignerCompany = styled.div`
	a {
		img {
			margin: 0 5px;
		}

		color: ${(p) => p.theme.color.white};
	}
`;

export const Version = styled.small`
	font-family: Arial;
`;
